import React from 'react'
import ListPageTemplate from './templates/ListPageTemplate'
import { sortByStartDate } from '../data/sorting'
import { FOCUS } from '../data/focus'
import LOG from '../logging/Logger'

export default props => {
  LOG.debug('Render: ScheduledPage')

  return (
    <ListPageTemplate
      list={FOCUS.TODAY.id}
      current={false}
      future={true}
      draggable={false}
      sortBy={sortByStartDate}
      showAdd={false}
      showShowAll={false}
      {...props}
    />
  )
}
